import React, { useState, useEffect } from "react";
import MainTable from "../../../components/Table/PaginationTable.js";
import { useNavigate, useParams } from "react-router-dom";
// import { columnDefDefaultFn } from '../Orders/columns/columnDef.js';
import { Button, Menu, MenuItem } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import {
  downloadTrfLabMarketing,
  fetchAllTrfLabAndTracer,
  shortlistTrf,
  unShortlistTrf,
  verifyTrf,
} from "../../../redux/trfUserSlice.js";
import FilterPanel from "../../../components/common components/FilterPanel.js";
import DownloadButton from "../../../components/common components/DownloadButton.js";
import FileOutlineIcon from "@mui/icons-material/Description";
import { TrfUserColumnDefDefaultFn } from "../../Orders/columns/columnDef.js";
import SuccessModal from "../../../components/Modals/SuccessfulModal.js";
import { useTranslation } from "react-i18next";
import VerifyTrfModalComponent from "../../../components/Modals/VerifyTrfModalComponent.js";
import NotVerifyModalComponent from "../../../components/Modals/NotVerifyModalComponent.js";
import NotVerifyReasonModalComponent from "../../../components/Modals/NotVerifyReasonModalComponent.js";
import RejectTrfModalComponent from "../../../components/Modals/RejectTrfModalComponent.js";
import dayjs from "dayjs";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import FilterPanelTrf from "../../../components/common components/FilterPanelTrf.js";
import TrfSuccessModal from "../../../components/Modals/TrfSuccessModal.js";
import DownloadExcelWithHeaders from "../../../components/common components/DownloadExcelWithHeaders.js";
// import dataJSON from "../columns/dummyData.json";
// import { Troubleshoot } from '@mui/icons-material';


const TrfUser = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  // const { data, loading, error } = useState(''); // Assuming the state shape
  //const tableData = useSelector(state => state.order.orderData) || []// console.log("****",state.order.data
  const isLoading = useSelector((state) => state.order.loading);
  const isError = useSelector((state) => state.order.error);
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
  const [isFilterPanelOpen, setIsFilterPanelOpen] = useState(false); // State to manage filter panel visibility
  const [isNotVerified, setIsNotVerified] = useState(false)
  const [isVerified, setIsVerified] = useState(false)
  const [isRejected, setIsRejected] = useState(false)
  const [filterCriteria, setFilterCriteria] = useState({
    search: "",
    fromDate: "",
    toDate: "",
  });

  // const { data, loading, error } = useSelector((state) => state.tableData); // Assuming the state shape
  const [pageNumber, setPageNumber] = useState(1); //  1-based indexing
  const [pageSize, setPageSize] = useState(10);
  const totalRecords =
    useSelector((state) => state.trfUser.trfPageInfo?.totalRecords) || 0;
  const navigate = useNavigate();
  const trfAllDetails = useSelector((state) => state.trfUser?.trfDetails) || [];
  const downloadTrfLabAndMarketing = useSelector((state) => state.trfUser?.downloadTrf) || [];
  // const downloadTrfLabAndMarketing1 = useSelector((state) =>console.log("downloadTrfLabAndMarketing1",state.trfUser?.downloadTrf))
  const [isVerifyModalOpen, setIsVerifyModalOpen] = useState(false);
  const [isNotVerifyModalOpen, setIsNotVerifyModalOpen] = useState(false);
  const [isRejectReasonModalOpen, setIsRejectReasonModalOpen] = useState(false);
  const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);
  const [isShortlisted, setIsShortlisted] = useState(false);
  const [isUnShortlisted, setIsUnShortlisted] = useState(false);
  // const userDetails = userDetailsResponse.payload.data[0]
  const userDetails = useSelector((state) => state?.auth.userDetails);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [trfDataById, setTrfDataById] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const [downloadFlag, setDownloadFlag] = useState(false);
  const open = Boolean(anchorEl);
  useEffect(() => {
    console.log(
      `Fetching with pageSize: ${pageSize}, pageNumber: ${pageNumber}`
    );
    const queryParams = {
      type: "all-trf",
      searchText: "",
      fromDate: "",
      toDate: "",
      pageSize, // Use state value
      pageNumber, // Use state value
      trfStatus: "",
    };
    dispatch(fetchAllTrfLabAndTracer(queryParams));
  }, [dispatch, pageSize, pageNumber]); // Include pageSize and pageNumber in the dependency array


  useEffect(() => {
    console.log(
      `Fetching with pageSize: ${pageSize}, pageNumber: ${pageNumber}`
    );
    const queryParams = {
      type: "lab-market-downloads",
      searchText: "",
      fromDate: "",
      toDate: "",
      pageSize, // Use state value
      pageNumber, // Use state value
    };
    dispatch(downloadTrfLabMarketing(queryParams));
  }, [dispatch, pageSize, pageNumber]); // Include pageSize and pageNumber in the dependency array

  
  const viewTrf = (trfId, actionType, trfData) => {
    // console.log("NAVIGATE CALL FOR VIEW", trfId, trfData);
    setTrfDataById(trfData);
    navigate(`/view-trf/${trfId}`); // Replace with your desired path
  };
  const shortlistUnShortlistTrf = (trfId, actionType) => {
    if (actionType == "shortlist") {
      const trfData = {
        type: "shortlist",
      };
      dispatch(shortlistTrf({ trfId, trfData })).then((response) => {
        //  if(response.payload.success) {
          
        setIsShortlisted(true);
        //  }
        const queryParams = {
          type: "all-trf",
          searchText: "",
          fromDate: "",
          toDate: "",
          pageSize, // Use state value
          pageNumber, // Use state value
          trfStatus: "",
        };
        dispatch(fetchAllTrfLabAndTracer(queryParams));
        setIsUnShortlisted(false);
      });
    } else if (actionType == "unShortlist") {
      const trfData = {
        type: "unshortlist",
      };
      dispatch(unShortlistTrf({ trfId, trfData })).then((response) => {
        // if(response.payload.success) {
        setIsUnShortlisted(true);
        // navigate(-1);
        // }
        const queryParams = {
          type: "all-trf",
          searchText: "",
          fromDate: "",
          toDate: "",
          pageSize, // Use state value
          pageNumber, // Use state value
          trfStatus: "",
        };
        dispatch(fetchAllTrfLabAndTracer(queryParams));
        setIsShortlisted(false);
      });
    }
  };
    console.log("downloadTrfLabAndMarketing1",downloadTrfLabAndMarketing,trfAllDetails)

  // Function to handle filter action
  const handleFilter = (criteria) => {
    const formattedCriteria = {
      search: criteria.search,
      fromDate: criteria.fromDate
        ? dayjs(criteria.fromDate).format("YYYY-MM-DD")
        : "",
      toDate: criteria.toDate
        ? dayjs(criteria.toDate).format("YYYY-MM-DD")
        : "",
      trfStatus: criteria.trfStatus,
    };
    setFilterCriteria(formattedCriteria);
    // Perform filtering logic based on criteria
    console.log("Filter criteria:", formattedCriteria);
    const queryParams = {
      type: "all-trf",
      searchText: formattedCriteria.search,
      fromDate: formattedCriteria.fromDate,
      toDate: formattedCriteria.toDate,
      pageSize,
      pageNumber,
      trfStatus: formattedCriteria.trfStatus,
    };
    dispatch(fetchAllTrfLabAndTracer(queryParams));
  };

  // Function to handle reset action
  const handleReset = () => {
    const queryParams = {
      type: "all-trf",
      searchText: "",
      fromDate: "",
      toDate: "",
      pageSize,
      pageNumber,
      trfStatus: "",
    };
    // Perform reset logic
    console.log("Filter criteria reset");
    dispatch(fetchAllTrfLabAndTracer(queryParams));
  };
  const verifyTrf = (trfId, actionType, trfRowData) => {
    setTrfDataById(trfRowData);
    setIsVerifyModalOpen(true);

    // console.log("INSIDE THE VERIFY TRF", trfId, actionType);
  };
  const notVerifyTrf = (trfId, actionType, trfRowData) => {
    setTrfDataById(trfRowData);
    setIsNotVerifyModalOpen(true);

    console.log("INSIDE THE NOT VERIFY TRF", trfRowData);
  };

  const rejectTrfReason = (trfId, actionType, trfRowData) => {
    setTrfDataById(trfRowData);
    setIsRejectReasonModalOpen(true);

    // console.log("INSIDE THE Reject TRF", trfRowData);
  };
  const rejectTrf = (trfId, actionType, trfRowData) => {
    setTrfDataById(trfRowData);
    setIsRejectModalOpen(true);

    console.log("INSIDE THE Reject TRF", trfRowData);
  };
  const columnDef = TrfUserColumnDefDefaultFn(
    viewTrf,
    shortlistUnShortlistTrf,
    verifyTrf,
    notVerifyTrf,
    rejectTrfReason,
    rejectTrf,
    t
  );

  const onPageIndexChange = (newPageIndex) => {
    setPageNumber(newPageIndex);
  };

  const onPageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setPageNumber(0); // Reset to the first page when page size changes
  };
  const onDeleteModalClose = () => {
    setIsVerifyModalOpen(false);
  };

  const onNotVerifyModalClose = () => {
    setIsNotVerifyModalOpen(false);
  };
  const onRejectModalClose = () => {
    setIsRejectReasonModalOpen(false);
  };
  const onRejectedModalClose = () => {
    setIsRejectModalOpen(false);
  };
  //Function to handle Export click
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  //Function to handle Export close
  const handleClose = () => {
    setAnchorEl(null);
    console.log("WHEN Success close")
  };
  //Function to downlaod Flag to true
  const handleDownloadFlag = () => {
    setDownloadFlag(true);
  };
  
  const updateStateForNotVerifiedSuccess = (newState) => {
    setIsNotVerified(newState);
    console.log("HERE IN updateStateForNotVerifiedSuccess",isNotVerified, newState)
  };

  const updateStateForVerifiedSuccess = (newState) => {
    setIsVerified(newState);
    console.log("HERE IN updateStateForVerifiedSuccess",isNotVerified, newState)
  };

  const updateStateForRejectSuccess = (newState) => {
    setIsRejected(newState);
    console.log("HERE IN updateStateForRejectSuccess",isNotVerified, newState)
  };
  // if (isLoading) return <div>Loading...</div>;
  if (isError) return <div>Error: {isError}</div>;

  return (
    <>
      <div className="btn-box py-3">
        <div className="d-flex justify-content-between">
          <div>
            
          </div>
          <div>
            <Button
              aria-controls="export-menu"
              aria-haspopup="true"
              style={{ backgroundColor: "#6AA13C" }}
              className="btn btn-primary greeen-btn md_btn m-2 h-100"
              startIcon={<FileOutlineIcon />}
              onClick={handleClick}
            >
              {/* {t("btnGrpText.downloadOrders")} */}
              Export
            </Button>
            <Menu
              id="export-menu"
              anchorEl={anchorEl}
              keepMounted
              open={open}
              onClose={handleClose}
            >
              <MenuItem onClick={handleClose}>
                {""}
                <DownloadExcelWithHeaders
                  data={downloadTrfLabAndMarketing}
                  fileName="Tracer Test Report.xlsx"
                  sheetName="Tracer Test"
                  forModule="Tracer Test"
                  onDownload={handleDownloadFlag}
                  BtnName="Tracer Test Report"
                  headerStyle={{
                    font: { bold: true },
                    fill: { fgColor: { rgb: 'FF0000' } }, // Red fill for headers
                    alignment: { horizontal: 'center' }
                  }}
                  customHeaders={{ courierId:"Reference Number", invoiceNumber:"Item Number", companyName:"Requested by", birlaFibre:"Birla Fibre", 
                  referenceCourierId:"Courier ID", status:"Status", companyName:"Applicant Name", companyAddress:"Applicant Address", country:"Applicant Country",
                  fabricOrderNumber:"Fabric Order Number", sampleBatchNumber:"Sample Batch Number", brandName:"Brand", garmenterName:"Garmenter", finishedFabricManufacturerName:"Finish Fabric Manufacturer",
                   greigeFabricManufacturerName:"Greige Fabric Manufacturer", spinnerName:"Spinner", claimedComposition:"Claimed Composition of Birla Fibre", warpWeft:"Fabric / Yarn count", 
                   fabricGsm:"Fabric GSM", testReferenceNumber:"Test Report No", productTypeName:"Product Type", tracerRegion:"Tracer Region", createdDate:"Created date",modifiedDate:"Submitted Date",
                   shortlistDate: "Shortlisted Date",  fromDate:"Production From Date", productionDate:"Production Date / To Date", 
                   testedDate:"Date of Sample Tested", notifyUsersEmail:"Notify users email", testedBy:"Tested by", rejectReason1:"Reject Reason 1", rejectReason2:"Reject Reason 2", rejectReason3:"Reject Reason 3",
                    rejectRemark:"Reject Remark", notVerifiedReasonText:"Not Verified Reason", sanitizedBrandName:"Sanitized Brand name", warpWeftBlend:"Claimed Composition", warpWeftConstruction:"Fabric Construction", warpWeftWidth:"Fabric Width(Inches)", 
                    productDetails:"Product details", yarnType:"Greige/ Dyed yarn" }}
                />
              </MenuItem>
            </Menu>
            <button
              className="btn btn-light grey-btn md_btn me-0"
              onClick={() => setIsFilterPanelOpen((prevState) => !prevState)}
            >
              <span>
                <i className="bi bi-funnel"><FilterAltOutlinedIcon /></i>
              </span>{" "}
              {t("orderOutboxcomponents.filters")}
            </button>
            {/* <button className="btn btn-primary greeen-btn md_btn">
              <span><i className="mdi mdi-file-document"></i></span>{t('btnGrpText.downloadOrders')}
            </button> */}
          </div>
        </div>
      </div>
      {isFilterPanelOpen && (
        <FilterPanelTrf
          className="mb-3"
          onFilter={handleFilter}
          onReset={handleReset}
          isFromDateToDate={true}
          isTrfStatus={true}
        />
      )}
      <MainTable
        columns={columnDef}
        data={trfAllDetails}
        initialPageSize={pageSize}
        pageNumber={pageNumber}
        onPageIndexChange={onPageIndexChange}
        onPageSizeChange={onPageSizeChange}
        enablePagination={true}
        totalRecords={totalRecords} // Pass the totalRecords to MainTable
        // className="custom-table-class"
        recordCountText="total records"
      />
      {isShortlisted && (
        <SuccessModal
          isOpen={isShortlisted}
          msg={"TRF Shortlisted Successfully"}
          navigatePage={"/trf"}
          forComponent={"Shortlisted"}
        />
      )}
      {isUnShortlisted && (
        <SuccessModal
          isOpen={isUnShortlisted}
          msg={"TRF UnShortlisted Successfully"}
          navigatePage={"/trf"}
          forComponent={"unShortlisted"}
        />
      )}
      {isVerifyModalOpen && (
        <VerifyTrfModalComponent
          isOpen={isVerifyModalOpen}
          onClose={onDeleteModalClose}
          //  handleDelete={handledVerifyTrf}
          trfDataById={trfDataById}
          userDetails={userDetails}
          updateStateForVerifiedSuccess={updateStateForVerifiedSuccess}
        />
      )}
      {isNotVerifyModalOpen && (
        <NotVerifyModalComponent
          isOpen={isNotVerifyModalOpen}
          onClose={onNotVerifyModalClose}
          //  handleDelete={handledVerifyTrf}
          trfDataById={trfDataById}
          updateStateForNotVerifiedSuccess={updateStateForNotVerifiedSuccess}
        />
      )}
      {isRejectReasonModalOpen && (
        <NotVerifyReasonModalComponent
          isOpen={isRejectReasonModalOpen}
          onClose={onRejectModalClose}
          //  handleDelete={handledVerifyTrf}
          trfDataById={trfDataById}
          forModule="reject"
        />
      )}
      {isRejectModalOpen && (
        <RejectTrfModalComponent
          isOpen={isRejectModalOpen}
          onClose={onRejectedModalClose}
          //  handleDelete={handledVerifyTrf}
          trfDataById={trfDataById}
          updateStateForRejectSuccess={updateStateForRejectSuccess}
        />
      )}
         {isNotVerified&& 
          <TrfSuccessModal
          isOpen={isNotVerified}
          msg={"TRF NOT Verified Successfully"}
          navigatePage={'/trf'}
          updateStateForNotVerifiedSuccess={updateStateForNotVerifiedSuccess}
          forComponent={"notVerify"}
          />
             }
                 {isVerified&& 
          <TrfSuccessModal
          isOpen={isVerified}
          msg={"TRF Verified Successfully"}
          navigatePage={'/trf'}
          updateStateForVerifiedSuccess={updateStateForVerifiedSuccess}
          forComponent={"verify"}
          />
             }
               {isRejected&& 
          <TrfSuccessModal
          isOpen={isRejected}
          msg={"TRF Rejected Successfully"}
          navigatePage={'/trf'}
          updateStateForRejectSuccess={updateStateForRejectSuccess}
          forComponent={"reject"}
          />
             }
    </>
  );
};

export default TrfUser;
